// NOTE: Centralized field length constants for form validation.
// Domain-specific lengths (MAX_MODEL_FIELD_LENGTH, MAX_PASSWORD_LENGTH, etc.)
// remain in their respective constant files.

export const FIELD_MAX_LENGTH = {
  // NOTE: Short names — assistant name, etc.
  SHORT: 50,
  // NOTE: Organization name, etc.
  MEDIUM: 80,
  // NOTE: Person name, folder name, etc.
  STANDARD: 100,
  // NOTE: Descriptions, chat titles, etc.
  LONG: 250,
  // NOTE: DB varchar default — probe name, model fields, etc.
  VARCHAR: 255,
  // NOTE: Long text — probe descriptions, behaviors, etc.
  TEXT: 500,
} as const;
